import SettingsDropdownPicker from './View';

export default SettingsDropdownPicker;
